/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum UserNotificationSubject {
    General = 0,
    RingRules = 1,
    Equipment = 2,
    Staffing = 3,
}
